import styled from 'styled-components';
import PropTypes from 'prop-types';

const getSize = (size) => {
    switch(size) {
        case 's':
            return '0.5rem';
        case 'm':
            return '1rem';
        case 'l':
            return '2.5rem';
        default:
            return '1rem';
    }
};

const Space = styled.div`
  height: ${props => getSize(props.size)};
`;

Space.defaultProps = {
    size: 'm',
};

Space.propTypes = {
    size: PropTypes.oneOf(['s', 'm', 'l']),
};

export default Space;